<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  mounted () {},
}
</script>

<style lang="scss">
body,
html {
  height: 100%;
}
#app {
  height: 100%;
  color: #0c0c0c;
}
</style>
